import {ARROW_VARIANT_LABELS, type ArrowGeometry} from '../../lib/lvs-arrow'
import {DataTable, ParamRow} from '../ui/data-table'
import {lvsRef, round4} from '../../lib/utils'

export interface ArrowParamsTableProps {
    readonly geometry: ArrowGeometry
}

const DIRECTION_GLYPH: Readonly<Record<ArrowGeometry['direction'], string>> = {
    left: 'Pa kreisi (←)',
    right: 'Pa labi (→)'
}

/**
 * Tabular dump of the geometry inputs and derived measurements with
 * per-row LVS references where applicable. Mirrors FoniParamsTable's
 * label/value/ref three-column layout via the shared ParamRow.
 */
export function ArrowParamsTable({geometry}: ArrowParamsTableProps) {
    const ratio = geometry.totalLength / geometry.h

    return (
        <DataTable>
            <DataTable.Head>
                <DataTable.HeadCell>Parametrs</DataTable.HeadCell>
                <DataTable.HeadCell>Vērtība</DataTable.HeadCell>
                <DataTable.HeadCell>Standarta atsauce</DataTable.HeadCell>
            </DataTable.Head>
            <tbody>
                <ParamRow
                    label='Virziens'
                    value={DIRECTION_GLYPH[geometry.direction]}
                    ref_='—'
                />
                <ParamRow
                    label='Variants'
                    value={ARROW_VARIANT_LABELS[geometry.variant]}
                    ref_={lvsRef('9.1', 'picture')}
                />
                <ParamRow
                    label='Atskaites augstums h'
                    value={`${round4(geometry.h)} mm`}
                    ref_='—'
                />
                <ParamRow
                    label='A vienība'
                    value={`${round4(geometry.A)} mm`}
                    ref_={lvsRef('9.1', 'picture')}
                />
                <ParamRow
                    label='Stieņa platums (1A)'
                    value={`${round4(geometry.stemWidth)} mm`}
                    ref_={lvsRef('9.1', 'picture')}
                />
                <ParamRow
                    label='Stieņa garums'
                    value={`${round4(geometry.stemLength)} mm (${geometry.stemA}A)`}
                    ref_='—'
                />
                <ParamRow
                    label='Galva — garums (3A)'
                    value={`${round4(geometry.headLength)} mm`}
                    ref_={lvsRef('9.1', 'picture')}
                />
                <ParamRow
                    label='Galva — pamatne (3A)'
                    value={`${round4(geometry.headBase)} mm`}
                    ref_={lvsRef('9.1', 'picture')}
                />
                <ParamRow
                    label='Barbu atkāpe (0.25A)'
                    value={`${round4(geometry.barbBack)} mm`}
                    ref_={lvsRef('9.1', 'picture')}
                />
                <ParamRow
                    label='Kopējais garums L'
                    value={`${round4(geometry.totalLength)} mm (${round4(ratio)}h)`}
                    ref_='—'
                />
                <ParamRow
                    label='Minimums L (705. zīme)'
                    value={`${round4(2.5 * geometry.h)} mm (2.5h)`}
                    ref_={lvsRef('9.37', 'clause')}
                />
            </tbody>
        </DataTable>
    )
}
